<template>
  <Dialog :visible="visible" modal @update:visible="deactivate"
   :style="{ width: '50rem' }" class="mx-4 black-bg items-center text-center overflow-hidden">
    <h2 class="text-white">{{ $t('LevelUpOverlayNoteComponent.congratulation') }}</h2>
    <div class="flex items-center my-1 mx-2 justify-center text-white">
      <div class="relative inline-flex justify-center items-center m-5">
        <i class="pi pi-star-fill text-[var(--color-disabled)]" style="font-size: 4.5rem;"></i>
        <span class="absolute font-bold text-4xl">{{ oldLevel() }}</span>
      </div>
      <font-awesome-icon icon="arrow-right" class="text-7xl"/>
      <div class="relative inline-flex justify-center items-center m-5">
        <i class="pi pi-star-fill star-accent-gradient" style="font-size: 6rem;"></i>
        <span class="absolute font-bold text-4xl">{{ newLevel() }}</span>
      </div>
    </div>
    <h3 class="text-white" v-html="$t('LevelUpOverlayNoteComponent.motivationalMessage')">
    </h3>
    <div class="mt-5 flex justify-center">
      <button @click.prevent="deactivate" class="btn-primary-accent px-3 py-1.5 sm:px-2 sm:py-1 
        w-fit sm:w-fit mx-0 sm:mx-auto text-sm sm:text-base mt-1">
        {{ $t('LevelUpOverlayNoteComponent.gotIt') }}
      </button>
    </div>
  </Dialog>
</template>

<script>
import { Dialog } from 'primevue';

export default {
  name: 'LevelUpOverlayNoteComponent',
  components: { Dialog },
  props: {
    overlay: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      visible: true,
    };
  },
  methods: {
    async deactivate() {
      this.$store.commit('advanceLevelUpQueue');
      if (!this.$store.getters.getLevelUpPopupShown) {
        this.visible = false;
        await this.$store.dispatch('getCurrentLevelInfo');
      }
    },
    oldLevel() {
      // Priority: 1) overlay content (notification path),
      // 2) store's captured old level, 3) current level
      if (this.overlay?.content?.oldLevel !== undefined) {
        return this.overlay.content.oldLevel;
      }
      // Use the captured old level from WebSocket event (stored before level was updated)
      const storedOldLevel = this.$store.getters.getLevelUpOldLevel;
      if (storedOldLevel !== null) {
        return storedOldLevel;
      }
      // Fallback to current level (shouldn't happen if WebSocket path works correctly)
      return this.$store.getters.getUserLevel;
    },
    newLevel() {
      // Priority: 1) overlay content (notification path),
      // 2) store's captured new level, 3) oldLevel + 1
      if (this.overlay?.content?.newLevel !== undefined) {
        return this.overlay.content.newLevel;
      }
      // Use the captured new level from WebSocket event
      const storedNewLevel = this.$store.getters.getLevelUpNewLevel;
      if (storedNewLevel !== null) {
        return storedNewLevel;
      }
      // Fallback to calculated value
      return this.oldLevel() + 1;
    },
  },
};
</script>

<style scoped>
.star-accent-gradient {
  background: var(--accent-gradient);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
</style>
